let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cPzVc")).then(() => parcelRequire('4J3kq'));